import { getSchema, MergeField, MergeSchema } from '../../decorators';
import { ActivityEntityName } from '../../../../entities';

@MergeSchema({
    entity: ActivityEntityName.Lead
})
export class LeadMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    stage: string;

    @MergeField()
    description: string;

    @MergeField()
    source: string;

    @MergeField()
    tags: string;

    @MergeField()
    createdAt: string;

    @MergeField()
    lastActivity: string;

    @MergeField()
    jobType: string;


}

export const LeadMergeSchema = getSchema(LeadMergeData);